import Articles from 'src/views/Pages/Dashboard/Supplying/Inventory/Article/Articles.vue';
import ArticlesCategories from 'src/views/Pages/Dashboard/Supplying/Inventory/ArticleCategory/ArticlesCategories.vue';
import CostCenters from 'src/views/Pages/Dashboard/Supplying/Inventory/CostCenter/CostCenters.vue';
import EmptyRouterView from 'src/views/Pages/GeneralViews/EmptyRouterView.vue';
import MasterTab from 'src/components/Layouts/MasterTab.vue';
import ProviderCreateEdit from 'src/views/Pages/Dashboard/Supplying/Inventory/Provider/ProviderCreateEdit.vue';
import Providers from 'src/views/Pages/Dashboard/Supplying/Inventory/Provider/Providers.vue';
import SupplyingCreateEdit from 'src/views/Pages/Dashboard/Supplying/Inventory/Supplying/SupplyingCreateEdit.vue';
import Supplyings from 'src/views/Pages/Dashboard/Supplying/Inventory/Supplying/Supplyings.vue';
import SupplyingUnits from 'src/views/Pages/Dashboard/Supplying/Inventory/SupplyingUnit/SupplyingUnits.vue';
import ToxicityClassifications from 'src/views/Pages/Dashboard/Supplying/Inventory/ToxicityClassification/ToxicityClassifications.vue';

const InventoryRoutes = {
  path: 'inventory',
  name: 'inventory.inventory',
  component: MasterTab,
  props: { reference: 'inventoryTabs' },
  children: [
    {
      path: 'supplyingunit',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.supplying_units',
          component: SupplyingUnits,
          meta: {
            prefix_permission: 'inventory_supplyingunit',
          },
        },
      ],
    },
    {
      path: 'articlecategory',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.article_category',
          component: ArticlesCategories,
          meta: {
            prefix_permission: 'inventory_articlecategory',
          },
        },
      ],
    },
    {
      path: 'toxicityclassification',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.toxicity_classification',
          component: ToxicityClassifications,
          meta: {
            prefix_permission: 'inventory_toxicityclassification',
          },
        },
      ],
    },
    {
      path: 'article',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.articles',
          component: Articles,
          meta: {
            prefix_permission: 'inventory_article',
          },
        },
      ],
    },
    {
      path: 'providerheader',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.suppliers',
          component: Providers,
          meta: {
            prefix_permission: 'inventory_providerheader',
          },
        },
        {
          path: 'create',
          name: 'inventory.suppliers',
          component: ProviderCreateEdit,
          meta: {
            prefix_permission: 'inventory_providerheader',
          },
        },
        {
          path: 'edit',
          name: 'inventory.suppliers',
          component: ProviderCreateEdit,
          meta: {
            prefix_permission: 'inventory_providerheader',
          },
        },
      ],
    },
    {
      path: 'supplying',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.supplyings',
          component: Supplyings,
          meta: {
            prefix_permission: 'inventory_supplying',
          },
        },
        {
          path: 'create',
          name: 'inventory.supplyings',
          component: SupplyingCreateEdit,
          meta: {
            prefix_permission: 'inventory_supplying',
          },
        },
        {
          path: 'edit',
          name: 'inventory.supplyings',
          component: SupplyingCreateEdit,
          meta: {
            prefix_permission: 'inventory_supplying',
          },
        },
      ],
    },
    {
      path: 'costcenter',
      component: EmptyRouterView,
      children: [
        {
          path: '',
          name: 'inventory.cost_center',
          component: CostCenters,
          meta: {
            prefix_permission: 'inventory_costcenter',
          },
        },
      ],
    },
  ]
};

export default InventoryRoutes;